/**
 * 回数の表記（layout-and-navigation.md §6 見積もり: カンマ区切り、`a × 10^b`、0 の個数）。
 * テキストの正本は `10^k`。画面では {@link splitPow} で上付きに分けて描く（{@html} を使わない）。
 */

export interface PowPart {
  text: string;
  /** true なら上付き（指数）。 */
  sup: boolean;
}

/** `4×10^10 回` → [`4×10`, sup `10`, ` 回`]。`^` の後の数字列だけを上付きにする。 */
export function splitPow(text: string): PowPart[] {
  const out: PowPart[] = [];
  const re = /\^(-?\d+)/g;
  let last = 0;
  for (const m of text.matchAll(re)) {
    const i = m.index;
    if (i > last) out.push({ text: text.slice(last, i), sup: false });
    out.push({ text: m[1] ?? '', sup: true });
    last = i + m[0].length;
  }
  if (last < text.length) out.push({ text: text.slice(last), sup: false });
  return out;
}

/** 上付きを `^k` のまま読める文字列にする（aria-label 用）。 */
export function powToSpeech(text: string): string {
  return text.replace(/10\^(-?\d+)/g, '10 の $1 乗');
}

/**
 * 「4 のあとに 0 が 10 個」。整数に丸めた値の末尾の 0 を数える。
 * 0 が無い・1,000 未満のときは「{桁数} 桁」。
 */
export function zerosText(x: number): string {
  if (!Number.isFinite(x) || x < 0) return '';
  const r = Math.round(x);
  if (r === 0) return '1 桁';
  const [mant = '0', e = '0'] = r.toExponential(14).split('e');
  const exp = Number(e);
  const digits = mant.replace('.', '').replace(/0+$/, '');
  if (exp >= 3 && digits.length <= 3) {
    return `${digits} のあとに 0 が ${exp - (digits.length - 1)} 個`;
  }
  return `${exp + 1} 桁`;
}
